import { useState } from 'react';
import { Button, VStack } from '@chakra-ui/react';

import Page from '@inspire/ui/chakra/layout/Page';
import Layout from 'components/layout/Layout';

import { useMyProfile, useResendVerificationEmail, useUser } from 'lib/hooks';
import {
  didntWorkToast,
  resentVerificationEmailToast,
  emailAdreadyUsedToast,
} from 'lib/toasts';
import { handleErrors } from 'lib/errors';

import { ERROR_MESSAGE_EMAIL_EXISTS } from '@inspire/data/static/error-codes';

const ValidationEmailPage = () => {
  const { isProf } = useUser();

  const [sentEmail, setSentEmail] = useState(false);
  const { refetchMyProfile } = useMyProfile();
  const { resendVerificationEmailAsync, isResendVerificationEmailLoading } =
    useResendVerificationEmail({
      onSuccess: async ({ resendVerificationEmail }) => {
        if (!resendVerificationEmail?.success) {
          didntWorkToast();
        } else {
          await refetchMyProfile();
          setSentEmail(true);
          resentVerificationEmailToast();
        }
      },
    });

  return (
    <Page title="Validation de l'adresse email" withPanel headingIsTitle>
      {isProf && (
        <div>
          Nous vous remercions de bien vouloir valider votre adresse email avant
          d’utiliser nos services. Un email avec un lien permettant de valider
          la création de votre compte vous a été envoyé. <br /> En cas de non
          réception, pensez à consulter vos spams.
        </div>
      )}
      {!isProf && (
        <div>
          Nous te remercions de bien vouloir valider ton adresse email avant
          d'utiliser nos services. Un email avec un lien permettant de valider
          la création de ton compte a été envoyé. <br />
          En cas de non réception, pense à consulter tes spams.
        </div>
      )}
      <VStack w="full" align="center" mt={8}>
        <Button
          isLoading={isResendVerificationEmailLoading}
          loadingText={isResendVerificationEmailLoading && 'Envoi en cours'}
          disabled={sentEmail}
          onClick={async () => {
            try {
              await resendVerificationEmailAsync();
            } catch (err) {
              console.error(err);
              handleErrors(err.errors, [
                ERROR_MESSAGE_EMAIL_EXISTS,
                () => emailAdreadyUsedToast(),
              ]);
            }
          }}
        >
          Renvoyer le lien
        </Button>
      </VStack>
    </Page>
  );
};

ValidationEmailPage.getWrappers = (page) => (
  <Layout rowVariant="yellow" containerWidth="sm" centerVertically>
    {page}
  </Layout>
);

export default ValidationEmailPage;
